module.exports = __webpack_public_path__ + "img/wawa3_slide_3.9250344e.jpg";